<template>
  <div class="meet_wrap container flex flex_content_sb">
    <div
      class="meet_left flex flex_wrap"
      :class="{ 'meet-en': langSet != 'cn' }"
    >
      <div class="meet-list" @click="toLink('/course?type=1', '会议列表')">
        <div>{{ langSet == "cn" ? "会议列表" : "Conference List" }}</div>
        <el-image
          class="meet-image"
          :src="require('../../../assets/icon_arrow.jpg')"
        ></el-image>
      </div>
      <div class="meet-list" @click="toLink('/guest', '会议嘉宾')">
        <div>{{ langSet == "cn" ? "会议嘉宾" : "Conference Speakers" }}</div>
        <el-image
          class="meet-image"
          :src="require('../../../assets/icon_arrow.jpg')"
        ></el-image>
      </div>
      <div class="meet-list" @click="toLink('/course?type=2', '线上课程')">
        <div>{{ langSet == "cn" ? "线上课程" : "Online Courses" }}</div>
        <el-image
          class="meet-image"
          :src="require('../../../assets/icon_arrow.jpg')"
        ></el-image>
      </div>
    </div>
    <div class="meet_right">
      <titleConfig
        :title="langSet == 'cn' ? '会议' : 'Conferences'"
        :type="1"
      ></titleConfig>
      <div class="meet-con" v-if="langSet == 'cn'">
        API
        China展会期间将举办30余场会议论坛，内容涵盖国内外制药行业热点话题，并将与中国化学制药工业协会、中国医药包装协会、国际药用辅料协会（中国）等多家国内外行业协会合作聚焦药品研发、质量控制、生产工艺、环保与安全、合规等热点话题，邀请100余位行业大咖与各个专题领域的头部专家及知名制药企业中的相关负责人现场分享。
      </div>
      <div class="meet-con meet-con-en" v-else>
        During API China, more than 30 conferences and forums will be held,
        covering the most pressing topics in the domestic and international
        pharmaceutical industry. In collaboration with leading industry
        associations, including the China Pharmaceutical Industry Association,
        the China National Pharmaceutical Packaging Association, the
        International Pharmaceutical Excipients Council (China), the exhibition will focus
        on key areas such as drug R&D, quality control, production processes,
        environmental protection and safety, and regulatory compliance. Over 100
        industry leaders, experts, and senior executives from renowned
        pharmaceutical enterprises will be invited to share cutting-edge
        insights and practical experiences on site.
      </div>
    </div>
  </div>
</template>
<script>
import titleConfig from "@/components/title.vue";
import { sdkClick } from "../../../sdk/useSdk";
export default {
  components: {
    titleConfig,
  },
  data() {
    return {
      langSet: "",
    };
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    toLink(path, title) {
      sdkClick("首页功能区", title);
      this.$router.push({ path });
    },
  },
};
</script>
<style lang="scss" scoped>
.meet_wrap {
  padding-top: 150px;
  margin-bottom: 150px;
  .meet_left {
    width: 560px;
    margin-right: 40px;
    .meet-list {
      width: 100%;
      height: 200px;
      color: #fff;
      font-size: 28px;
      line-height: 40px;
      padding: 60px 40px;
      margin-bottom: 15px;
      box-sizing: border-box;
      border-radius: 30px;
      background: rgba($color: #1d2379, $alpha: 0)
        url("../../../assets/meet_bg1.png") no-repeat;
      background-size: 100%;
      cursor: pointer;
      &:nth-child(2) {
        width: 345px;
        margin-right: 15px;
        background: url("../../../assets/meet_bg2.png") no-repeat;
        background-size: 100%;
      }
      &:nth-child(3) {
        width: 200px;
        background: url("../../../assets/meet_bg3.png") no-repeat;
        background-size: 100%;
      }
      &:hover {
        background: #1d2379;
        transition: all 0.3s linear;
      }
      .meet-image {
        width: 26px;
        height: 22px;
        margin-top: 23px;
      }
    }
  }
  .meet_right {
    flex: 1;
    height: 415px;
    padding: 40px 50px;
    box-sizing: border-box;
    background: #f9fafc;
    border-radius: 30px;
    .meet-con {
      font-size: 22px;
      color: #001a33;
      line-height: 40px;
      margin-top: 10px;
    }
    .meet-con-en {
      font-size: 16px;
      line-height: 26px;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .meet_wrap {
    align-items: center;
    .meet_right {
      height: auto;
      min-height: 415px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .meet_wrap {
    padding: 0.9rem 0;
    margin-bottom: 0;
    flex-wrap: wrap;
    flex-direction: column-reverse;
    .meet_left {
      width: 100%;
      margin-right: 0;
      .meet-list {
        height: 2.25rem;
        font-size: 0.35rem;
        border-radius: 20px;
        line-height: 0.48rem;
        overflow: hidden;
        padding: 0.58rem 0 0 0.3rem;
        &:nth-child(2) {
          width: 4.2rem;
        }
        &:nth-child(3) {
          width: 2.25rem;
        }
      }
    }
    .meet-en {
      .meet-list {
        font-size: 0.3rem;
        &:nth-child(2) {
          width: 3.4rem;
          background-size: cover;
        }
        &:nth-child(3) {
          width: 3rem;
        }
      }
    }
    .meet_right {
      padding: 0;
      min-height: auto;
      background: #fff;
      margin-bottom: 0.58rem;
      .meet-con {
        font-size: 0.29rem;
        line-height: 0.46rem;
        margin-top: 0.38rem;
      }
    }
  }
}
</style>